// extracted by mini-css-extract-plugin
export default {"gray500":"#adb5bd","Page":"Page_Page__pDuKI"};